import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withKeys as _withKeys, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { ref: "recaptchaDiv" }
const _hoisted_2 = { class: "ion-padding-top ion-text-center" }
const _hoisted_3 = {
  target: "_blank",
  href: "https://fdmt.hk"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_card_title = _resolveComponent("ion-card-title")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_logo_img = _resolveComponent("logo-img")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_grid, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_row, { class: "ion-justify-content-center" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, {
                    class: "ion-no-padding",
                    size: "12",
                    "size-md": $props.isPage ? 8 : 12,
                    "size-lg": $props.isPage ? 6 : 12,
                    "size-xl": $props.isPage ? 4 : 12
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_card, { class: "login-card ion-no-margin" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_buttons, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_button, {
                                fill: "clear",
                                onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.closeModal()))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, {
                                    size: "small",
                                    slot: "icon-only",
                                    icon: $setup.arrowBack
                                  }, null, 8, ["icon"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_card_header, {
                            class: "ion-text-center",
                            style: {"padding-top":"0"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_card_title, null, {
                                default: _withCtx(() => _cache[4] || (_cache[4] = [
                                  _createTextVNode("AchieveBot")
                                ])),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_card_content, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_input, {
                                label: $setup.t('phone'),
                                "label-placement": "floating",
                                inputmode: "numeric",
                                fill: "outline",
                                modelValue: $setup.phone,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.phone) = $event)),
                                maxlength: "8",
                                onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => ($setup.doSMSLogin($setup.phone)), ["enter"]))
                              }, null, 8, ["label", "modelValue"]),
                              _withDirectives(_createVNode(_component_ion_text, { color: "danger" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("small", null, [
                                    _createElementVNode("b", null, _toDisplayString($setup.t('RegisterPage.unregisteredPhone')), 1)
                                  ])
                                ]),
                                _: 1
                              }, 512), [
                                [_vShow, $setup.isInvalidPhone]
                              ]),
                              _createVNode(_component_ion_button, {
                                class: "submit-btn ion-margin-bottom",
                                expand: "block",
                                onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.doSMSLogin($setup.phone))),
                                disabled: $setup.phone.length != 8
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString($setup.t('next')) + " ", 1),
                                  _createVNode(_component_ion_icon, {
                                    slot: "end",
                                    icon: $setup.arrowForward
                                  }, null, 8, ["icon"]),
                                  _createElementVNode("div", _hoisted_1, _cache[5] || (_cache[5] = [
                                    _createElementVNode("div", { id: "grecaptcha-div" }, null, -1)
                                  ]), 512)
                                ]),
                                _: 1
                              }, 8, ["disabled"]),
                              _createElementVNode("p", _hoisted_2, [
                                _createElementVNode("a", _hoisted_3, [
                                  _createVNode(_component_logo_img, { withText: false })
                                ])
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["size-md", "size-lg", "size-xl"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}